import moment from 'moment';
import { NotifMailSearchDTOPaginateItems } from '../interfaces/me/notif-mails-dto.interface';
import { TranslateService } from '@devinforius/i-essentials';

export class NavbarNotification {
  tagValue?: string;
  formattedDate: string = '';
  text: string = '';
  courrierId: number;
  isRead: boolean = false;
  actionId: string;
  linkClick?: () => unknown;
  actionClick?: () => unknown;

  constructor(data: NotifMailSearchDTOPaginateItems, transator: TranslateService) {
    const dataAsObject = JSON.parse(data.data);
    if (dataAsObject.Action === '') {
      this.tagValue = transator.translate('administration.notifParams.addRecipient');
      this.text = '#' + dataAsObject.CourrierId + ' ' + dataAsObject.Objet;
    } else {
      this.tagValue = transator.translate('administration.notifParams.addAction');
      this.text = '#' + dataAsObject.CourrierId + ' ' + dataAsObject.Action;
    }

    if (dataAsObject.creationDate) {
      this.formattedDate = moment(dataAsObject.creationDate).format('DD/MM/YYYY à HH:mm');
    }

    this.courrierId = dataAsObject.CourrierId;
    this.isRead = dataAsObject.lu;
    this.actionId = data.id;
  }
}
